// extracted by mini-css-extract-plugin
export var divider = "_xl-0";